/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiComponentBlockCategoryFromJSON, ApiComponentBlockCategoryToJSON, } from './ApiComponentBlockCategory';
import { ApiComponentTypeFromJSON, ApiComponentTypeToJSON, } from './ApiComponentType';
import { ApiComponentUISourceFromJSON, ApiComponentUISourceToJSON, } from './ApiComponentUISource';
import { ApiReadLanderResponseFromJSON, ApiReadLanderResponseToJSON, } from './ApiReadLanderResponse';
import { ApiSimpleComponentAIPromptFromJSON, ApiSimpleComponentAIPromptToJSON, } from './ApiSimpleComponentAIPrompt';
import { ApiSimplePersonalisationFromJSON, ApiSimplePersonalisationToJSON, } from './ApiSimplePersonalisation';
import { ApiSimpleProjectFromJSON, ApiSimpleProjectToJSON, } from './ApiSimpleProject';
import { ApiSimpleUserFromJSON, ApiSimpleUserToJSON, } from './ApiSimpleUser';
export function ApiSimpleComponentFromJSON(json) {
    return ApiSimpleComponentFromJSONTyped(json, false);
}
export function ApiSimpleComponentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aiCss': !exists(json, 'aiCss') ? undefined : json['aiCss'],
        'aiHtml': !exists(json, 'aiHtml') ? undefined : json['aiHtml'],
        'aiJs': !exists(json, 'aiJs') ? undefined : json['aiJs'],
        'category': !exists(json, 'category') ? undefined : ApiComponentBlockCategoryFromJSON(json['category']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'css': !exists(json, 'css') ? undefined : json['css'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'favicon': !exists(json, 'favicon') ? undefined : json['favicon'],
        'grapeJs': !exists(json, 'grapeJs') ? undefined : json['grapeJs'],
        'head': !exists(json, 'head') ? undefined : json['head'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'js': !exists(json, 'js') ? undefined : json['js'],
        'lastUser': !exists(json, 'lastUser') ? undefined : ApiSimpleUserFromJSON(json['lastUser']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : ApiSimpleUserFromJSON(json['owner']),
        'path': !exists(json, 'path') ? undefined : ApiReadLanderResponseFromJSON(json['path']),
        'pending': !exists(json, 'pending') ? undefined : json['pending'],
        'personalisations': !exists(json, 'personalisations') ? undefined : (json['personalisations'].map(ApiSimplePersonalisationFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiSimpleProjectFromJSON(json['project']),
        'prompt': !exists(json, 'prompt') ? undefined : ApiSimpleComponentAIPromptFromJSON(json['prompt']),
        'promptId': !exists(json, 'promptId') ? undefined : json['promptId'],
        'screenshotTaken': !exists(json, 'screenshotTaken') ? undefined : json['screenshotTaken'],
        'seoDescrition': !exists(json, 'seoDescrition') ? undefined : json['seoDescrition'],
        'seoTitle': !exists(json, 'seoTitle') ? undefined : json['seoTitle'],
        'theme': !exists(json, 'theme') ? undefined : json['theme'],
        'type': !exists(json, 'type') ? undefined : ApiComponentTypeFromJSON(json['type']),
        'uiSource': !exists(json, 'uiSource') ? undefined : ApiComponentUISourceFromJSON(json['uiSource']),
    };
}
export function ApiSimpleComponentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aiCss': value.aiCss,
        'aiHtml': value.aiHtml,
        'aiJs': value.aiJs,
        'category': ApiComponentBlockCategoryToJSON(value.category),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'css': value.css,
        'description': value.description,
        'externalId': value.externalId,
        'favicon': value.favicon,
        'grapeJs': value.grapeJs,
        'head': value.head,
        'html': value.html,
        'id': value.id,
        'js': value.js,
        'lastUser': ApiSimpleUserToJSON(value.lastUser),
        'name': value.name,
        'owner': ApiSimpleUserToJSON(value.owner),
        'path': ApiReadLanderResponseToJSON(value.path),
        'pending': value.pending,
        'personalisations': value.personalisations === undefined ? undefined : (value.personalisations.map(ApiSimplePersonalisationToJSON)),
        'project': ApiSimpleProjectToJSON(value.project),
        'prompt': ApiSimpleComponentAIPromptToJSON(value.prompt),
        'promptId': value.promptId,
        'screenshotTaken': value.screenshotTaken,
        'seoDescrition': value.seoDescrition,
        'seoTitle': value.seoTitle,
        'theme': value.theme,
        'type': ApiComponentTypeToJSON(value.type),
        'uiSource': ApiComponentUISourceToJSON(value.uiSource),
    };
}
